export default __webpack_public_path__ + "static/media/check-down.fa3bfba9.svg";